import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectRatio1To316(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconMediaObjectRatio1To316"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4 4v8a1 1 0 1 1-2 0V4a1 1 0 0 1 2 0M1 4a2 2 0 1 1 4 0v8a2 2 0 1 1-4 0zm6.511-1a.5.5 0 1 0 0 1h6.967a.5.5 0 0 0 0-1zm-.5 2.5a.5.5 0 0 1 .5-.5h4.18a.5.5 0 0 1 0 1h-4.18a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6.967a.5.5 0 0 1 0 1H7.51a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h4.18a.5.5 0 0 1 0 1H7.51a.5.5 0 0 1-.5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectRatio1To316);
